import { EventName, EventType, NetworkEventData, RCEvent } from "../../core/eventhub/eventmodels.js"
import { EventController } from '../../core/eventhub/eventcontroller.js'
import { RidecellCallback } from '../../core/models/ridecellcallback.js'
import { CarsharingNetworkRequests } from "../networkrequestsbuilder.js"

export class VehicleCheckout {

    
    getRidecellCallback(resolve, reject) {
        const ridecellCallback = new RidecellCallback();
        ridecellCallback.onSuccess = result => {
            resolve(result)
        }
        ridecellCallback.onFailure = error => {
            reject(error)
        };
        return ridecellCallback;
    }

    getSupportPhoneNumber() {
        return new Promise((resolve, reject) => {
            const eventData = new NetworkEventData(EventType.GET, CarsharingNetworkRequests.getSupportPhoneNumber)

            this.sendEvent(new RCEvent(EventName.NETWORK, eventData, this.getRidecellCallback(resolve, reject)));
        })
    }

    getPolicyDocuments() {
        return new Promise((resolve, reject) => {
            const eventData = new NetworkEventData(EventType.GET, CarsharingNetworkRequests.policyDocuments)

            this.sendEvent(new RCEvent(EventName.NETWORK, eventData, this.getRidecellCallback(resolve, reject)));
        })
    }

    associateCustomerToBusiness({ formDataParam }) {
        // formDataParam: reservation_reference_id
        return new Promise((resolve, reject) => {
            const formData = new FormData()
            Object.entries(formDataParam).forEach(([key, value]) => formData.append(key, value))

            const associateEventData = new NetworkEventData(EventType.PATCH, CarsharingNetworkRequests.associateCustomerToBusiness, null, formData, true)
        
            this.sendEvent(new RCEvent(EventName.NETWORK, associateEventData, this.getRidecellCallback(resolve, reject)));
        })
    }

    getVehicleList({ queryParams }) {
        // queryParams: id
        return new Promise((resolve, reject) => {

            const { id } = queryParams
            const vehilcesData = new NetworkEventData(EventType.GET, CarsharingNetworkRequests.vehicleList(id))

            this.sendEvent(new RCEvent(EventName.NETWORK, vehilcesData, this.getRidecellCallback(resolve, reject)));
        })
    }

    getRentalInfo({ queryParams }) {
        // queryParams: id
        return new Promise((resolve, reject) => {
            
            const { id } = queryParams
            const rentalInfoEventData = new NetworkEventData(EventType.GET, CarsharingNetworkRequests.rentalInfo(id))

            this.sendEvent(new RCEvent(EventName.NETWORK, rentalInfoEventData, this.getRidecellCallback(resolve, reject)));
        })
    }

    associateVehicleDriver({ queryParams, formDataParam}) {
        // queryParams: fleetRentalId
        // formDataParam: customer_id, vehicle_id
        return new Promise((resolve, reject) => {

            const { fleetRentalId } = queryParams
            const formData = new FormData()
            Object.entries(formDataParam).forEach(([key, value]) => formData.append(key, value))

            const associateEventData = new NetworkEventData(EventType.PATCH, CarsharingNetworkRequests.associateVehicleDriver(fleetRentalId), null, formData, true)

            this.sendEvent(new RCEvent(EventName.NETWORK, associateEventData, this.getRidecellCallback(resolve, reject)));
        })
    }

    getJumioAuthLink({ formDataParam }) {
        // formDataParam: workflow
        return new Promise((resolve, reject) => {

            const formData = new FormData()
            Object.entries(formDataParam).forEach(([key, value]) => formData.append(key, value))
    
            const jumioAuthEventData = new NetworkEventData(EventType.POST, CarsharingNetworkRequests.vehicleCheckoutJumioAuthentication, null, formData, false)
    
            this.sendEvent(new RCEvent(EventName.NETWORK, jumioAuthEventData, this.getRidecellCallback(resolve, reject)));
        })
    }

    getJumioAuthStatus({ queryParams }) {
        // queryParams: customerId, workflowId
        return new Promise((resolve, reject) => {

            const { customerId, workflowId } = queryParams
            const jumioAuthEventData =  new NetworkEventData(EventType.GET, CarsharingNetworkRequests.jumioAuthStatus(customerId, workflowId))

            this.sendEvent(new RCEvent(EventName.NETWORK, jumioAuthEventData, this.getRidecellCallback(resolve, reject)));
        })
    }

    getInspectionReport({ queryParams }) {
        // queryParams: rentalId, vehicleId, base64
        return new Promise((resolve, reject) => {

            const { rentalId, vehicleId, base64 } = queryParams
            const path = base64 ? `${CarsharingNetworkRequests.inspectionReport(rentalId, vehicleId)}&base64=true` : CarsharingNetworkRequests.inspectionReport(rentalId, vehicleId)

            const inspectionReportEventData = new NetworkEventData(EventType.GET, path)

            this.sendEvent(new RCEvent(EventName.NETWORK, inspectionReportEventData, this.getRidecellCallback(resolve, reject)));
        })
    }

    getRentalAgreement({ queryParams }) {
        // queryParams: rentalId, vehicleId, customerId, base64
        return new Promise((resolve, reject) => {

            const { rentalId, vehicleId, customerId, base64 } = queryParams
            const path = base64 ? `${CarsharingNetworkRequests.rentalAgreement(rentalId, vehicleId, customerId)}&base64=true` : CarsharingNetworkRequests.rentalAgreement(rentalId, vehicleId, customerId)

            const rentalAgreementEventData = new NetworkEventData(EventType.GET, path)

            this.sendEvent(new RCEvent(EventName.NETWORK, rentalAgreementEventData, this.getRidecellCallback(resolve, reject)));
        })
    }

    signInspectionReport({ queryParams, formDataParam }) {
        // queryParams: rentalId
        // formDataParam: vehicle_id, signature_image
        return new Promise((resolve, reject) => {

            const { rentalId } = queryParams
            const formData = new FormData()
            Object.entries(formDataParam).forEach(([key, value]) => formData.append(key, value))

            const signEventData = new NetworkEventData(
                EventType.POST,
                CarsharingNetworkRequests.signInspectionReport(rentalId),
                null, 
                formData,
                false,
                true
            );

            this.sendEvent(new RCEvent(EventName.NETWORK, signEventData, this.getRidecellCallback(resolve, reject)));
        })
    }

    signRentalAgreement({ queryParams, formDataParam }) {
        // queryParams: rentalId
        // formDataParam: vehicle_id, signature_image
        return new Promise((resolve, reject) => {

            const { rentalId } = queryParams
            const formData = new FormData()
            Object.entries(formDataParam).forEach(([key, value]) => formData.append(key, value))

            const signEventData = new NetworkEventData(
                EventType.POST,
                CarsharingNetworkRequests.signRentalAgreement(rentalId),
                null, 
                formData,
                false,
                true
            );

            this.sendEvent(new RCEvent(EventName.NETWORK, signEventData, this.getRidecellCallback(resolve, reject)));
        })
    }

    getCustomerRentalInfo() {
        return new Promise((resolve, reject) => {

            const rentalInfo = new NetworkEventData(EventType.GET, CarsharingNetworkRequests.getCustomerRentalInfo)

            this.sendEvent(new RCEvent(EventName.NETWORK, rentalInfo, this.getRidecellCallback(resolve, reject)));
        })
    }

    updateDoorStatus({ queryParams, formDataParam }) {
        // queryParams: vehicleId
        // formDataParam: door_status
        return new Promise((resolve, reject) => {

            const { vehicleId } = queryParams
            const formData = new FormData()
            Object.entries(formDataParam).forEach(([key, value]) => formData.append(key, value))

            const updateDoorStatusData = new NetworkEventData(EventType.POST, CarsharingNetworkRequests.updateDoorStatus(vehicleId), null, formData, false, true);

            this.sendEvent(new RCEvent(EventName.NETWORK, updateDoorStatusData, this.getRidecellCallback(resolve, reject)));
        })
    }

    getCarsharingRental({ queryParams }) {
        // queryParams: id
        return new Promise((resolve, reject) => {

            const { id } = queryParams
            const rentalData = new NetworkEventData(EventType.GET, CarsharingNetworkRequests.carsharingRental(id))

            this.sendEvent(new RCEvent(EventName.NETWORK, rentalData, this.getRidecellCallback(resolve, reject)));
        })
    }

    createCarSharingRental({ formDataParam }) {
        // formDataParam : start_date, instant_rental, reservation_mode, rental_mode, customer_id, vehicle_id, role, expand, product
        return new Promise((resolve, reject) => {
            
            const formData = new FormData()
            Object.entries(formDataParam).forEach(([key, value]) => formData.append(key, value))

            const rentalData = new NetworkEventData(
                EventType.POST,
                CarsharingNetworkRequests.createCarSharingRental,
                null, 
                formData,
                false,
                true
            );
            
            this.sendEvent(new RCEvent(EventName.NETWORK, rentalData, this.getRidecellCallback(resolve, reject)));
        })
    }

    endCarSharingRental({ queryParams, formDataParam }) {
        // queryParams: id
        // formDataParam: end_datetime
        return new Promise((resolve, reject) => {

            const { id } = queryParams
            const formData = {}
            Object.entries(formDataParam).forEach(([key, value]) => formData[key] = value)

            const rentalData = new NetworkEventData(
                EventType.POST,
                CarsharingNetworkRequests.endCarSharingRental(id),
                null, 
                formData,
                false,
                true
            );

            this.sendEvent(new RCEvent(EventName.NETWORK, rentalData, this.getRidecellCallback(resolve, reject)));
        })
    }

    removeVehicleFromFleet({ queryParams, formDataParam }) {
        // queryParams: fleetId
        // formDataParam: vehicleId
        return new Promise((resolve, reject) => {

            const { fleetId } = queryParams
            const { vehicleId } = formDataParam
            const formData = {
                "vehicle_ids": [vehicleId]
            }

            const rentalData = new NetworkEventData(
                EventType.POST,
                CarsharingNetworkRequests.removeVehicleFromFleet(fleetId),
                null, 
                formData,
                false,
                true
            );

            this.sendEvent(new RCEvent(EventName.NETWORK, rentalData, this.getRidecellCallback(resolve, reject)));
        })
    }

    postRating({ queryParams, formDataParam }) {
        // queryParams: id
        // formDataParam: score, comment, reasons([])
        return new Promise((resolve, reject) => {

            const { id } = queryParams
            const formData = {}
            Object.entries(formDataParam).forEach(([key, value]) => formData[key] = value)

            const rentalData = new NetworkEventData(
                EventType.POST,
                CarsharingNetworkRequests.ratings(id),
                null, 
                formData,
                false,
                true
            );

            this.sendEvent(new RCEvent(EventName.NETWORK, rentalData, this.getRidecellCallback(resolve, reject)));
        })
    }

    sendEvent(event) {
        EventController.addEvent(event);
    }
    
}